function Hero() {
  return (
    <section className="p-md-5" id="hero">
      <p className="p2 mono-font">Hi, my name is</p>
      <h1>John Davies</h1>
      <p className="p1">
        I&apos;m a software engineer building on AWS and Bitcoin.
      </p>
    </section>
  );
}

export default Hero;
